import digitalDynamixLogo from "../assets/digital-dynamix.png";
import { ExternalLinkIcon, ParachuteIcon } from "./Icons";

export function ValidatorFooter() {
  return (
    <footer className="validator-footer" aria-label="Digital Dynamix validator">
      <a
        href="http://portal.flare.network/staking"
        target="_blank"
        rel="noreferrer"
        aria-label="Stake FLR with Digital Dynamix Validator. Monthly DYNMX airdrops for stakers (new tab)"
      >
        <span className="validator-footer__brand">
          <img src={digitalDynamixLogo} alt="Digital Dynamix" />
        </span>
        <span className="validator-footer__message">
          <small>Staker benefit</small>
          <strong><ParachuteIcon /> Monthly DYNMX airdrops</strong>
        </span>
        <span className="validator-footer__action">Stake FLR <ExternalLinkIcon /></span>
      </a>
    </footer>
  );
}
